// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchbar-container input[type=text] {
  font-weight: lighter;
}
.searchbar-container input[type=text]:focus {
  font-weight: lighter;
}

.popover-container > div {
  border: none;
  border-radius: 0;
  box-shadow: 0 0 10px 3px rgba(30, 32, 37, 0.12);
}
.popover-container input[type=checkbox] {
  border-color: #000;
  border-radius: 0;
}
.popover-container .clear-btn {
  background-color: #FFF;
  border: 1px solid #0A4FAE;
  border-radius: 0;
  color: #0A4FAE;
  font-weight: bold;
}
.popover-container .apply-btn {
  background-color: #0A4FAE;
  border-radius: 0;
  color: #fff;
}
.popover-container .accordion-item {
  border: none;
}
.popover-container .accordion-body {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.popover-container .accordion-body div {
  margin-bottom: 0 !important;
}
.popover-container .accordion-button {
  font-size: 12px;
  font-weight: bold;
}
.popover-container .accordion-button:not(.collapsed) {
  background-color: #EBEDEF;
  box-shadow: none;
  color: #000;
}
.popover-container .form-label {
  color: #000;
}
.popover-container .show-all-btn {
  background-color: transparent;
  border: none;
  color: #0A4FAE;
  padding: 0;
}
.popover-container .show-all-btn:hover {
  background-color: transparent !important;
  border: none !important;
  color: #CEE0F5 !important;
  padding: 0;
}

.filterbubble-container > div > span {
  display: flex;
  align-items: center;
  background-color: #EBEDEF !important;
  border: 1px solid #AAB0BD;
  font-size: 14px;
  padding: 0 0.5rem;
}
.filterbubble-container h6 {
  color: #667085;
  margin-right: 0.25rem;
  margin-bottom: 0;
}
.filterbubble-container p {
  color: #0A4FAE;
  margin-right: 0.25rem;
  margin-bottom: 0;
}
.filterbubble-container .col-auto {
  margin-bottom: 0.5rem;
  padding: 0 0.5rem;
}
.filterbubble-container span button {
  background-color: transparent;
  border: 1px solid transparent;
  color: #828282;
  padding: 0 0.25rem;
}
.filterbubble-container span button:hover {
  background-color: #FFBDAD !important;
  border: 1px solid transparent !important;
  color: #DE350B !important;
}
.filterbubble-container div > button {
  background-color: #CEE0F5;
  border: 1px solid #0A4FAE;
  border-radius: 2rem;
  color: #0A4FAE;
  font-weight: bold;
  padding: 0 0.5rem;
}
.filterbubble-container div > button:hover {
  background-color: #FFBDAD !important;
  border: 1px solid #DE350B !important;
  color: #DE350B !important;
}

@media (max-width: 822px) {
  .border-end-none {
    border-right: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./../jobportal/src/components/HomeContent/SearchBar/SearchBar.scss"],"names":[],"mappings":"AACE;EACE,oBAAA;AAAJ;AAGE;EACE,oBAAA;AADJ;;AAME;EACE,YAAA;EACA,gBAAA;EACA,+CAAA;AAHJ;AAME;EACE,kBAAA;EACA,gBAAA;AAJJ;AAOE;EACE,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AALJ;AAQE;EACE,yBAAA;EACA,gBAAA;EACA,WAAA;AANJ;AASE;EACE,YAAA;AAPJ;AAUE;EACE,mBAAA;EACA,sBAAA;AARJ;AAWE;EACE,2BAAA;AATJ;AAYE;EACE,eAAA;EACA,iBAAA;AAVJ;AAaE;EACE,yBAAA;EACA,gBAAA;EACA,WAAA;AAXJ;AAcE;EACE,WAAA;AAZJ;AAeE;EACE,6BAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;AAbJ;AAgBE;EACE,wCAAA;EACA,uBAAA;EACA,yBAAA;EACA,UAAA;AAdJ;;AAmBE;EACE,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;AAhBJ;AAmBE;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;AAjBJ;AAoBE;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;AAlBJ;AAqBE;EACE,qBAAA;EACA,iBAAA;AAnBJ;AAsBE;EACE,6BAAA;EACA,6BAAA;EACA,cAAA;EACA,kBAAA;AApBJ;AAuBE;EACE,oCAAA;EACA,wCAAA;EACA,yBAAA;AArBJ;AAwBE;EACE,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AAtBJ;AAyBE;EACE,oCAAA;EACA,oCAAA;EACA,yBAAA;AAvBJ;;AA2BA;EACE;IACE,6BAAA;EAxBF;AACF","sourcesContent":[".searchbar-container {\n  input[type=\"text\"] {\n    font-weight: lighter;\n  }\n  \n  input[type=\"text\"]:focus {\n    font-weight: lighter;\n  }\n}\n\n.popover-container {\n  > div {\n    border: none;\n    border-radius: 0;\n    box-shadow: 0 0 10px 3px rgba(30, 32, 37, 0.12);\n  }\n\n  input[type=\"checkbox\"] {\n    border-color: #000;\n    border-radius: 0;\n  }\n\n  .clear-btn {\n    background-color: #FFF;\n    border: 1px solid #0A4FAE;\n    border-radius: 0;\n    color: #0A4FAE;\n    font-weight: bold;\n  }\n\n  .apply-btn {\n    background-color: #0A4FAE;\n    border-radius: 0; \n    color: #fff;\n  }\n\n  .accordion-item {\n    border: none;\n  }\n\n  .accordion-body {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n\n  .accordion-body div {\n    margin-bottom: 0 !important;\n  }\n\n  .accordion-button {\n    font-size: 12px;\n    font-weight: bold;\n  }\n\n  .accordion-button:not(.collapsed) {\n    background-color: #EBEDEF;\n    box-shadow: none;\n    color: #000;\n  }\n\n  .form-label {\n    color: #000;\n  }\n\n  .show-all-btn {\n    background-color: transparent;\n    border: none;\n    color: #0A4FAE;\n    padding: 0;\n  }\n\n  .show-all-btn:hover {\n    background-color: transparent !important;\n    border: none !important;\n    color: #CEE0F5 !important;\n    padding: 0;\n  }\n}\n\n.filterbubble-container {\n  > div > span {\n    display: flex;\n    align-items: center;\n    background-color: #EBEDEF !important;\n    border: 1px solid #AAB0BD;\n    font-size: 14px;\n    padding: 0 0.5rem;\n  }\n\n  h6 {\n    color: #667085;\n    margin-right: 0.25rem;\n    margin-bottom: 0;\n  }\n\n  p {\n    color: #0A4FAE;\n    margin-right: 0.25rem;\n    margin-bottom: 0;\n  }\n\n  .col-auto {\n    margin-bottom: 0.5rem;\n    padding: 0 0.5rem;\n  }\n\n  span button {\n    background-color: transparent;\n    border: 1px solid transparent;\n    color: #828282;\n    padding: 0 0.25rem ;\n  }\n\n  span button:hover {\n    background-color: #FFBDAD !important;\n    border: 1px solid transparent !important;\n    color: #DE350B !important;\n  }\n\n  div > button {\n    background-color: #CEE0F5;\n    border: 1px solid #0A4FAE;\n    border-radius: 2rem;\n    color: #0A4FAE;\n    font-weight: bold;\n    padding: 0 0.5rem;\n  }\n\n  div > button:hover {\n    background-color: #FFBDAD !important;\n    border: 1px solid #DE350B !important;\n    color: #DE350B !important;\n  }\n}\n\n@media (max-width: 822px) {\n  .border-end-none  {\n    border-right: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
